import { render } from "./ServicesList.vue?vue&type=template&id=1218322a&scoped=true"
import script from "./ServicesList.vue?vue&type=script&lang=js"
export * from "./ServicesList.vue?vue&type=script&lang=js"

import "./ServicesList.vue?vue&type=style&index=0&id=1218322a&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1218322a"]])

export default __exports__